import React, { useEffect, useState, useCallback } from "react";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { api } from "../../api";
import { customStyles } from "../../styles/dataTableStyles";



const MerchantRequests = ({ addAccess }) => {
  const token = useSelector((state) => state.auth.token);
  const { userType: role } = useSelector((state) => state.auth.user);
  const region = useSelector((state) => state.auth.region);

  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [pageSize, setPageSize] = useState(50);




  const navigate = useNavigate();

  const fetchMerchantRequests = useCallback(async (pageNo, searchKey, pageSize) => {
    try {
      setLoading(true);
      const response = await api.merchants.getMerchantListRequest({
        pageNo,
        pageSize,
        sort: "desc",
        sortBy: "id",
        searchKey
      }, token);

      if (response.success) {
        setRequests(response.data.results);
        setTotalRows(response.data.totalCount);
      } else {
        setRequests([]);
        setTotalRows(0);
      }
    } catch (error) {
      console.error("Error fetching merchant requests", error);
       setRequests([]);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
        setPage(1);
      // eslint-disable-next-line
    }, [search]);

  useEffect(() => {
    const delaySearch = setTimeout(() => {
      fetchMerchantRequests(page, search, pageSize);
    }, 500);

    return () => clearTimeout(delaySearch);
  }, [page, search, pageSize, fetchMerchantRequests]);






  const editMerchant = (merchentId) => {
    navigate(`/merchant-request/${merchentId}`);
  };





  const columns = [
    { name: "ID", selector: row => row.merchantId, sortable: true, width: "80px" },
    { name: region.currency ? `Merchant Name (${region.currency})` : "Merchant Name", selector: row => row.merchantName, sortable: true },
    { name: "Email", selector: row => row.merchantEmail,width: "250px" },
    { name: "Contact Person", selector: row => row.merchantContactPerson },
    { name: "Phone", selector: row => row.merchantMobile, width: "120px" },
    {
      name: "Status",
      selector: row => (row.merchantStatus === 1 ? "Accepted" : "Pending"),
      cell: row => (
        <span style={{
          padding: "5px 10px",
          borderRadius: "5px",
          color: row.merchantStatus ? "#44aa44" : "#ff4b4b",
          display: "inline-block",
          minWidth: "80px",
          textAlign: "center"
        }}>
          {row.merchantStatus ? "Accepted" : "Pending"}
        </span>
      ),
      width: "120px"
    },
    {
      name: "Actions",
      cell: (row) => (
        <div style={{ display: "flex", gap: "5px", flexWrap: "wrap" }}>
                {(role === 1 || role === 2) && row.merchantStatus === 0 && (
            <button className="btn btn-primary btn-sm" onClick={() => editMerchant(row.merchantId)}>Edit</button>
           )}
        
        </div>
      ),
      ignoreRowClick: true,
     
      width: "100px"
    }
  ];

  return (
    <div className="container-fluid mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="sec-header">MERCHANT REQUESTS</h2>
        <div className="d-flex align-items-center">
          <label className="mr-2">Search:</label>
          <input
            type="text"
            placeholder="Merchant Name"
            className="form-control"
            style={{ width: "200px" }}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>

      <DataTable
        columns={columns}
        data={requests}
        progressPending={loading}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        onChangePage={setPage}
        paginationPerPage={pageSize}
        onChangeRowsPerPage={(newPageSize, newPage) => {
          setPageSize(newPageSize);
          setPage(newPage);
        }}
        paginationRowsPerPageOptions={[50, 100,150,200]}
        highlightOnHover
        customStyles={customStyles}
        responsive
        noHeader={false}
      />

      
    </div>
  );
};

export default MerchantRequests;
